import React from "react";
import { WHATSAPP_AFFILIATE } from "../mock";
import { MessageCircle, TrendingUp, DollarSign, Sparkles, CheckCircle2 } from "lucide-react";

export default function AffiliateSection() {
  const benefits = [
    { icon: DollarSign, title: "Attractive commissions", desc: "Earn every time someone buys through your link." },
    { icon: TrendingUp, title: "Grow your brand", desc: "Partner with a premium Brazilian hair care label." },
    { icon: Sparkles, title: "Free training", desc: "Content ideas, scripts and product knowledge." },
  ];

  const steps = [
    "Send us a message on WhatsApp",
    "Get your unique affiliate link",
    "Share it — earn on every sale",
  ];

  return (
    <section id="affiliate" className="section scroll-mt-24 bg-gradient-to-b from-[#FBF8F4] to-[#F5EFE6] relative" data-testid="affiliate-section">
      <div className="container-y">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-sans-y text-[11px] tracking-[0.35em] uppercase text-[#C9A961] mb-4">
            Partner Program
          </p>
          <h2 className="font-serif-y text-4xl md:text-6xl leading-[1.05] text-[#1a1a1a] mb-6">
            Become a Ybera <span className="italic text-[#C9A961]">Affiliate</span>
          </h2>
          <p className="font-sans-y text-base text-[#444] leading-relaxed">
            Turn your love for beauty into income. Join a growing network of creators, stylists
            and hair enthusiasts monetizing their audience with a brand people trust.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {benefits.map((b) => {
            const Icon = b.icon;
            return (
              <div
                key={b.title}
                className="bg-white p-8 border border-[#EAE3D8] hover:border-[#C9A961] transition-colors flex flex-col items-start gap-4"
              >
                <div className="w-12 h-12 bg-[#C9A961]/15 flex items-center justify-center text-[#C9A961]">
                  <Icon size={22} />
                </div>
                <h4 className="font-serif-y text-2xl text-[#1a1a1a]">{b.title}</h4>
                <p className="font-sans-y text-[14px] text-[#555] leading-relaxed">{b.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="bg-[#1a1a1a] text-[#FBF8F4] p-8 md:p-14 grid lg:grid-cols-2 gap-10 items-center relative overflow-hidden">
          <div
            className="absolute -top-24 -right-24 w-80 h-80 rounded-full opacity-20 blur-3xl"
            style={{ background: "#C9A961" }}
          />
          <div className="relative">
            <p className="font-sans-y text-[11px] tracking-[0.35em] uppercase text-[#C9A961] mb-4">
              How it works
            </p>
            <h3 className="font-serif-y text-3xl md:text-4xl mb-8">
              Start earning in 3 simple steps
            </h3>
            <ul className="flex flex-col gap-4">
              {steps.map((s, i) => (
                <li key={i} className="flex items-start gap-4">
                  <CheckCircle2 size={22} className="text-[#C9A961] shrink-0 mt-0.5" />
                  <span className="font-sans-y text-[15px] text-[#e8e2d6]">
                    <span className="font-semibold text-[#FBF8F4] mr-2">0{i + 1}.</span>
                    {s}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="relative flex flex-col items-start lg:items-end gap-4">
            <a href={WHATSAPP_AFFILIATE} target="_blank" rel="noreferrer" className="btn-whatsapp">
              <MessageCircle size={18} />
              I want to be an affiliate
            </a>
            <p className="font-sans-y text-[12px] tracking-[0.15em] text-[#8a8578]">
              Talk to us directly on WhatsApp: <span className="text-[#C9A961]">+55 (13) 98167-5693</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
